import type { PaletteOptions } from '@mui/material/styles'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import { rgbaStrOpacity } from 'src/utils/colors'

export const blueDark = 'rgba(85, 143, 255, 1)'
export const blueMedium = 'rgba(108, 176, 255, 1)'
export const blueLight = 'rgba(235, 247, 254, 1)'

export const roadHighlight = 'rgba(255, 255, 0, 1)'
export const roadSelected = 'rgba(193, 13, 70, 1)'

export const pinkPin = 'rgba(252, 57, 137, 1)'

export const redExtraDark = 'rgba(193, 13, 70, 1)'
export const redDark = 'rgba(248, 43, 98, 1)'
export const redMedium = 'rgba(255, 65, 116, 1)'
export const redLight = 'rgba(254, 237, 241, 1)'
export const redExtraLight = 'rgba(249, 238, 238, 1)'

export const yellowDark = 'rgba(254, 192, 72, 1)'
export const yellowMedium = 'rgba(255, 203, 103, 1)'
export const yellowLight = 'rgba(255, 244, 222, 1)'

export const orangeDark = 'rgba(255, 159, 67, 1)'
export const orangeMedium = 'rgba(255, 171, 50, 1)'
export const orangeLight = 'rgba(255, 238, 220, 1)'

export const greenDark = 'rgba(30, 228, 179, 1)'
export const greenMedium = 'rgba(65, 246, 201, 1)'
export const greenLight = 'rgba(232, 252, 247, 1)'

// TODO(ss): need to replace above greens with new ones
export const bgGreenExtraDark = 'rgba(17, 179, 129, 1)'
export const bgGreenDark = 'rgba(20, 204, 148, 1)'
export const bgGreenMedium = 'rgba(114, 224, 191, 1)'
export const bgGreenLight = 'rgba(161, 235, 212, 1)'
export const bgGreenExtraLight = 'rgba(220, 247, 239, 1)'

export const tealDark = 'rgba(33, 184, 176, 1)'
export const tealShadow = 'rgba(33, 184, 176, 0.2)'

export const bgDark = 'rgba(245, 246, 251, 1)'
export const bgMedium = 'rgba(246, 249, 252, 1)'
export const bgLight = 'rgba(251, 251, 255, 1)'
export const bgWhite = 'rgba(255, 255, 255, 1)'
export const bgTableHeader = 'rgba(237, 247, 253, 1)'

export const bgAltBlue = 'rgba(242, 247, 251, 1)'
export const bgAltGreen = 'rgba(238, 251, 248, 1)'

export const bgGrey = 'rgba(126, 133, 140, 1)'
export const bgLightGrey = 'rgba(244, 244, 244, 1)'

export const bgDarkBlue = 'rgba(22, 38, 56, 1)'
export const bgBlack = 'rgba(13, 22, 33, 1)'

export const mobileNotchGrey = `rgb(155, 155, 155, 1)`

export const shadow = 'rgba(29, 31, 48, 1)'
export const shadowI = 'rgba(29, 31, 48, 0.04)'
export const shadowII = 'rgba(29, 31, 48, 0.03)'
export const shadowInput = 'rgba(29, 31, 48, 0.02)'
export const shadowInputHover = 'rgba(29, 31, 48, 0.05)'
export const shadowOverlay = 'rgba(29, 31, 48, 0.35)'

export const border = 'rgba(230, 237, 244, 1)'
export const borderInput = 'rgba(214, 223, 233, 1)'
export const borderInputHover = 'rgba(197, 206, 215, 1)'

export const textDark = 'rgba(71, 77, 87, 1)'
export const textMedium = 'rgba(98, 110, 123, 1)'
export const textLight = 'rgba(124, 136, 148, 1)'

export const textNavItem = 'rgba(212, 215, 218,1)'

export const textAltDarkBlue = 'rgba(80, 142, 191, 1)'
export const textAltBlueMedium = 'rgba(105, 202, 243, 1)'

export const textBlack = 'rgba(0, 0, 0, 1)'
export const textWhite = 'rgba(255, 255, 255, 1)'
export const textGreyBlue = 'rgba(46, 51, 61, 1)'

export const textDisabled = 'rgba(196, 201, 227, 1)'

export const tradeAreaPrimary = 'rgba(247, 42, 42, 1)'
export const tradeAreaSecondary = 'rgba(252, 148, 43, 1)'
export const tradeAreaTertiary = 'rgba(255, 217, 48, 1)'

export const tradeAreaOnePrimary = 'rgba(248, 43, 98, 1)'
export const tradeAreaOneSecondary = 'rgba(254, 113, 151, 1)'
export const tradeAreaOneTertiary = 'rgba(255, 199, 214, 1)'

export const tradeAreaTwoPrimary = 'rgba(1, 79, 229, 1)'
export const tradeAreaTwoSecondary = 'rgba(85, 143, 255, 1)'
export const tradeAreaTwoTertiary = 'rgba(169, 214, 255, 1)'

export const tradeAreaThreePrimary = 'rgba(49, 206, 255, 1)'
export const tradeAreaThreeSecondary = 'rgba(36, 200, 159, 1)'
export const tradeAreaThreeTertiary = 'rgba(127, 228, 203, 1)'

export const tradeAreaFourPrimary = 'rgba(250, 153, 7, 1)'
export const tradeAreaFourSecondary = 'rgba(248, 183, 59, 1)'
export const tradeAreaFourTertiary = 'rgba(255, 221, 156, 1)'

export const tradeAreaIntersection = 'rgba(160, 80, 222, 1)'

export const mapOverlayRadius = 'rgba(166, 182, 199, 1)'

export const buttonStandard = 'rgba(85, 143, 255, 0.15)'
export const buttonSelected = 'rgba(85, 143, 255, 0.25)'
export const buttonGray = 'rgba(0, 0, 0, 0.12)'
export const buttonGrayText = 'rgba(0, 0, 0, 0.26)'

export const purpleExtraDark = 'rgba(77, 69, 161, 1)'
export const purpleDark = 'rgba(94, 82, 233, 1)'
export const purpleLight = 'rgba(216, 223, 254, 1)'

export const pricingBlue = 'rgb(107, 176, 255, 1)'
export const pricingGreen = 'rgb(125, 232, 205, 1)'
export const pricingRed = 'rgb(238, 83, 125, 1)'
export const pricingYellow = 'rgb(236, 198, 121, 1)'

export const reportRulerBorder = 'rgba(217, 217, 217, 1)'
export const reportRulerBackground = 'rgba(232, 234, 237, 1)'

export const userListItemBackgroundHover = 'rgba(166, 182, 199, 0.1)'

export const reportPlaces = [redDark, greenDark, yellowDark, blueDark]
export const reportPlacesHighlight = [redLight, greenLight, yellowLight, blueLight]

export const actionBarBg = 'rgba(235, 247, 254, 1)'
export const actionBarDivider = 'rgba(239, 239, 244, 1)'

export const customAreaFill = 'rgba(85, 143, 255, .25)'
export const customAreaStroke = 'rgba(85, 143, 255, .85)'

export const matchAnalysisModalHeader = 'rgb(65, 76, 88)'
export const matchAnalysislHeader = 'rgba(214, 223, 233,1)'

export const matchAnalysislBorder = 'rgba(174, 184, 198, 1)'

export const matchAnalysisExplanationHeader = 'rgba(65,  76,  88,  1)'

export const neutral50 = 'rgba(244, 246, 247, 1)'
export const neutral100 = 'rgba(228, 231, 233, 1)'
export const neutral200 = 'rgba(203, 209, 214, 1)'
export const neutral300 = 'rgba(167, 176, 185, 1)'
export const neutral400 = 'rgba(124, 136, 148, 1)'
export const neutral500 = 'rgba(98, 110, 123, 1)'
export const neutral600 = 'rgba(83, 92, 103,1)'
export const neutral700 = 'rgba(71, 77, 87, 1)'
export const neutral800 = 'rgba(63, 68, 75, 1)'
export const neutral900 = 'rgba(56, 60, 65, 1)'
export const neutral950 = 'rgba(34, 37, 42, 1)'

export const primaryBlue900 = 'rgba(26, 44, 142, 1)'
export const primaryBlue800 = 'rgba(25, 45, 180, 1)'
export const primaryBlue600 = 'rgba(31, 75, 241, 1)'
export const primaryBlue500 = 'rgba(53, 108, 252, 1)'
export const primaryBlue400 = 'rgba(85, 143, 255, 1)'
export const primaryBlue200 = 'rgba(189, 212, 255, 1)'
export const primaryBlue100 = 'rgba(218, 230, 255, 1)'
export const primaryBlue50 = 'rgba(238, 244, 255, 1)'

export const rankRed100 = 'rgba(253, 230, 233, 1)'

export const rankGreen100 = 'rgba(233, 248, 207, 1)'
export const rankGreen200 = 'rgba(210, 242, 164, 1)'
export const rankGreen400 = 'rgba(149, 215, 64, 1)'
export const rankGreen900 = 'rgba(51, 78, 25, 1)'

export const primaryRed50 = 'rgba(255, 241, 243, 1)'
export const primaryRed100 = 'rgba(255, 227, 232, 1)'
export const primaryRed200 = 'rgba(255, 204, 215, 1)'
export const primaryRed400 = 'rgba(254, 110, 145, 1)'
export const primaryRed500 = 'rgba(248, 43, 98, 1)'
export const primaryRed600 = 'rgba(230, 24, 89, 1)'
export const primaryRed700 = 'rgba(194, 14, 75, 1)'
export const primaryRed800 = 'rgba(163, 14, 69, 1)'

export const statusRed50 = 'rgba(254, 242, 244, 1)'
export const statusRed300 = 'rgba(246, 171, 184, 1)'
export const statusRed500 = 'rgba(227, 65, 100, 1)'

export const primaryYellow600 = 'rgba(219, 96, 4, 1)'
export const primaryYellow400 = 'rgba(253, 169, 34, 1)'
export const primaryYellow100 = 'rgba(255, 237, 198, 1)'
export const primaryYellow800 = 'rgba(148, 50, 12, 1)'

export const primaryGreen900 = 'rgba(0, 49, 42, 1)'
export const primaryGreen800 = 'rgba(0, 86, 73, 1)'
export const primaryGreen700 = 'rgba(0, 105, 86, 1)'
export const primaryGreen600 = 'rgba(0, 133, 109, 1)'
export const primaryGreen500 = 'rgba(0, 166, 130, 1)'
export const primaryGreen400 = 'rgba(0, 204, 159, 1)'
export const primaryGreen300 = 'rgba(30, 228, 179, 1)'
export const primaryGreen200 = 'rgba(97, 244, 203, 1)'
export const primaryGreen100 = 'rgba(159, 251, 220, 1)'
export const primaryGreen50 = 'rgba(234, 255, 247, 1)'

export const grayBlue100 = 'rgba(232, 236, 241, 1)'
export const grayBlue900 = 'rgba(71, 79, 97, 1)'
export const grayBlue950 = 'rgba(46, 51, 61, 1)'

export const reportsBlue800 = 'rgba(25, 73, 180, 1)'
export const reportsPurple400 = 'rgba(127, 136, 250, 1)'

export const muiPallete: PaletteOptions = {
  primary: {
    main: blueMedium,
    light: blueLight,
    dark: blueDark,
    contrastText: textWhite,
  },
  secondary: {
    main: redMedium,
    light: redLight,
    dark: redDark,
    contrastText: textWhite,
  },
  error: {
    main: redMedium,
    light: redLight,
    dark: redDark,
    contrastText: textWhite,
  },
  warning: {
    main: yellowMedium,
    light: yellowLight,
    dark: yellowDark,
    contrastText: textDark,
  },
  info: {
    main: blueMedium,
    light: blueLight,
    dark: blueDark,
    contrastText: textWhite,
  },
  success: {
    main: greenMedium,
    light: greenLight,
    dark: greenDark,
    contrastText: textDark,
  },
  text: {
    primary: textDark,
    secondary: textMedium,
    disabled: textWhite,
  },
  divider: border,
  background: {
    default: bgMedium,
    paper: bgLight,
  },
}

export const SKETCH_PICKER_DEFAULT_PRESET_COLORS = Object.freeze([
  '#D0021B',
  '#F5A623',
  '#F8E71C',
  '#8B572A',
  '#7ED321',
  '#417505',
  '#BD10E0',
  '#9013FE',
  // fixed defaults
  '#558FFF', // AlphaMap blueDark
  '#1EE4B3', // AlphaMap greenDark
  '#FEC148', // AlphaMap yellowDark
  '#F82B62', // AlphaMap redDark
  '#000000', // black
  '#4D4D4D', // dark gray
  '#DCDCDC', // css Gainsboro
  '#F5F5F5', // css WhiteSmoke
])

export const BOX_SHADOW = `0 4px 6px -1px ${rgbaStrOpacity(bgBlack, 0.1)},0 2px 4px -1px ${rgbaStrOpacity(
  bgBlack,
  0.07
)}`
export const BOX_SHADOW_LEFT_INSET = `inset 4px 0 6px -1px ${rgbaStrOpacity(bgBlack, 0.1)},inset 2px 0 4px -1px ${rgbaStrOpacity(bgBlack, 0.07)}`

export const DIVIDER_MOBILE = '#dadada'

export const ZONE_PARCEL_COLORS = {
  commercial: {
    main: 'rgb(106, 81, 163)',
    commercialCondo: 'rgb(248, 247, 254)',
    generalCommercial: 'rgb(158, 154, 200)',
    industrial: 'rgb(188, 189, 220)',
    manufacturing: 'rgb(218, 218, 235)',
    mixedUse: 'rgb(106, 81, 163)',
    office: 'rgb(128, 125, 186)',
    retail: 'rgb(63, 0, 125)',
    storage: 'rgb(239, 237, 245)',
  },
  housing: {
    main: 'rgb(66, 146, 198)',
    apartments: 'rgb(8, 69, 148)',
    miscResidence: 'rgb(241, 248, 255)',
    multiFamily: 'rgb(33, 113, 181)',
    residential: 'rgb(107, 174, 214)',
    residentialCondo: 'rgb(158, 202, 225)',
    singleFamilyResidence: 'rgb(198, 219, 239)',
  },
  land: {
    main: 'rgb(65, 174, 118)',
    agriculture: 'rgb(0, 88, 36)',
    mobileHome: 'rgb(237, 248, 233)',
    recreation: 'rgb(199, 233, 192)',
    timberland: 'rgb(161, 217, 155)',
    vacant: 'rgb(35, 139, 69)',
    vacantAgricutlture: 'rgb(65, 171, 93)',
    vacantIndustrial: 'rgb(116, 196, 118)',
    vacantResidential: 'rgb(116, 196, 118)',
  },
  largeScaleHousing: {
    main: 'rgb(247, 104, 161)',
    hotel: 'rgb(250, 159, 181)',
    motel: 'rgb(253, 224, 221)',
  },
  publicSpaces: {
    main: 'rgb(241, 105, 19)',
    educational: 'rgb(127, 39, 4)',
    government: 'rgb(166, 54, 3)',
    historical: 'rgb(217, 72, 1)',
    hospital: 'rgb(241, 105, 19)',
    medicalServices: 'rgb(79, 31, 12)',
    misc: 'rgb(255, 245, 235)',
    parking: 'rgb(254, 230, 206)',
    services: 'rgb(253, 141, 60)',
    transportation: 'rgb(253, 174, 107)',
    unknown: 'rgb(135, 135, 135)',
    utilities: 'rgb(253, 208, 162)',
  },
}

const MOBILITY_PURPLE = purpleDark
const MOBILITY_PINK = 'rgba(227, 26, 94,1)'
const MOBILITY_GREEN = 'rgba(76, 175, 80,1)'
const MOBILITY_ORANGE = 'rgba(244, 81, 30,1)'
const MOBILITY_BLUE = 'rgba(30, 136, 229,1)'
const MOBILITY_MAGENTA = 'rgba(177, 13, 201,1)'
const MOBILITY_TEAL = 'rgba(0, 137, 123,1)'
const MOBILITY_BROWN = 'rgba(121, 85, 72,1)'
export const MOBILITY_LINE_COLORS = [
  MOBILITY_PURPLE,
  MOBILITY_PINK,
  MOBILITY_GREEN,
  MOBILITY_ORANGE,
  MOBILITY_BLUE,
  MOBILITY_TEAL,
  MOBILITY_MAGENTA,
  MOBILITY_BROWN,
]

export const TTA_DEMO_COMPARE_COLORS = [
  'rgba(94, 82, 233, 1)',
  'rgba(227, 26, 94, 1)',
  'rgba(76, 175, 80, 1)',
  'rgba(244, 81, 30, 1)',
  'rgba(30, 136, 229, 1)',
  'rgba(177, 13, 201, 1)',
  'rgba(0, 137, 123, 1)',
  'rgba(121, 85, 72, 1)',
]

export const TTA_DEMO_OVERLAP_COLOR = 'rgba(255, 229, 0, 1)'

export const INSIGHT_WIDGET_COLORS: Record<InsightBuilderWidget['type'], string> = {
  'Property Records': orangeDark,
  Zoning: orangeDark,
  'True Trade Area': purpleDark,
  'Location Visits': purpleDark,
  'Area Visits': purpleDark,
  Rank: purpleDark,
  'Category Rank': purpleDark,
  'Shopping Center Overview': purpleDark,
  Demographics: blueDark,
  'Car Traffic': blueDark,
  'Radius Rings Trade Area': blueDark,
  'Drive Time Trade Area': blueDark,
  Image: tealDark,
  Text: tealDark,
  Map: tealDark,
}
